import {
  Autocomplete,
  Box,
  Button,
  Divider,
  Drawer,
  Grid,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { BASE_IMAGE_URL, BASE_URL } from "../../../config/apiConfig";

import ClickableImage from "../../../components/layout/Interactive/Images/ClickableImage";
import { getHeaders } from "../../../utils/apiUtils";
import { showAlert } from "../../../components/common/userFeedback/CustomAlert";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import { useAmpltiudeEventTrackingContext } from "../../../contexts/AmplitudeTrackingContext";
import SeedGarment from "../../../components/ui/cards/SeedGarment";
import LoadingOverlay from "../../../components/common/userFeedback/LoadingOverlay";
import { APP_BAR_HEIGHT } from "../../../components/layout/AppBar/AppBarComponent";
import NoDataScreenCover from "../../../components/common/userFeedback/NoDataScreenCover";
import DatasetDropdown from "../../../components/forms/Dropdowns/DatasetDropdown";
import PineconeIndexDropdown from "../../../components/forms/Dropdowns/PineconeIndexDropdown";
import { ToolProvider, useToolContext } from "../../../contexts/ToolContext";
import { useParams } from "react-router-dom";
import ImageIndexButtons from "../../../components/ui/buttons/ImageIndexButtons";
import StyledImageCarousel from "../../../components/ui/StyledImageCarousel";
import { formatToSpacedCapitalizedWords, logPerformancePoint } from "../../../utils/sharedFunctions";
import CustomModal from "../../../components/common/userFeedback/CustomModal";
import MassImageApprovalsFrame from "../../../components/layout/Interactive/MassImageApprovalsFrame";
import LoadingBar from "../../../components/ui/LoadingBar";
import GarmentPanel from "../../../components/ui/cards/GarmentPanel";
import { useAuth } from "../../../contexts/AuthContext";

function AggregationTool(props) {
  const theme = useTheme();
  const { isAdmin, isToolTester } = useAuth();
  const [garments, setGarments] = useState([]);
  const [seedGarment, setSeedGarment] = useState(null);
  const [garmentID, setGarmentID] = useState(null);
  const [publicGarmentId, setPublicGarmentId] = useState(null);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(18);
  const [openSearchIndexes, setOpenSearchIndexes] = useState([]);
  const {
    inputFilters,
    jobDetails,
    toolType,
    filterHardness,
    datasets,
    jobDataLoaded,
    shownAttributes,
  } = useToolContext();
  const [selectedGarments, setSelectedGarments] = useState([]);
  const [ignoredGarments, setIgnoredGarments] = useState([]);
  const [garmentsSelectedOnPage, setGarmentsSelectedOnPage] = useState(0);
  const [ignoredGarmentsObject, setIgnoredGarmentsObject] = useState({});
  const [selectedGarmentsObject, setSelectedGarmentsObject] = useState({});
  const [totalAggregations, setTotalAggregations] = useState(0);
  const [totalIgnoredGarments, setTotalIgnoredGarments] = useState(0);
  const [anyDataLoading, setAnyDataLoading] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [similarItemsDataLoading, setSimilarItemsDataLoading] = useState(false);
  const [proposalDataLoading, setProposalDataLoading] = useState(false);
  const [openSearchIndex, setOpenSearchIndex] = useState("off-white");
  const [pagesWithoutTag, setPagesWithoutTag] = useState(0);
  const [tagMadeOnPage, setTagMadeOnPage] = useState(true);
  const [totalGarmentsSeen, setTotalGarmentsSeen] = useState(0);
  const [garmentsSeen, setGarmentsSeen] = useState(0);
  const [imageIndex, setImageIndex] = useState(1);
  const [seedGarmentImages, setSeedGarmentImages] = useState([]);
  const [seedPresentedTimestamp, setSeedPresentedTimestamp] = useState(Date.now())
  const [presentedTimestamp, setPresentedTimestamp] = useState(Date.now())
  const [indexSummary, setIndexSummary] = useState({});
  const [selectedDataset, setSelectedDataset] = useState(null);
  const { trackEvent } = useAmpltiudeEventTrackingContext();
  const [skipOrCreateOpen, setSkipOrCreateOpen] = useState(false);
  const [summonTotal, setSummonTotal] = useState(0);
  const [time, setTime] = useState(0);
  const timerLengthSeconds = (isToolTester && isAdmin) ? 0 : 45;

  const [toolID, setToolID] = useState(0);
  const toolName = 'AggregationTool'

  const [numberOfColumns, setNumberOfColumns] = useState(5); // Default to 3 columns
  useEffect(() => {
    setPageSize(numberOfColumns * 3);
    setPage(1);
    setGarments([]);
  }, [numberOfColumns]);

  useEffect(() => {
    const selectedGarmentIds = selectedGarments.map(g => g.garment_id)
    garments.forEach((garment, index) => {
      if (selectedGarmentIds.includes(garment.garment_id))
      {
        selectedGarmentsObject[garment.garment_id] = {
          score: garment.score,
          rank: index + 1 + (page - 1) * pageSize,
          proposed_timestamp: new Date().toISOString(),
          presented_timestamp: garment.presented_timestamp
        };
        delete ignoredGarmentsObject[garment.garment_id];
      } else {
        ignoredGarmentsObject[garment.garment_id] = {
          score: garment.score,
          rank: index + 1 + (page - 1) * pageSize,
          proposed_timestamp: new Date().toISOString(),
          presented_timestamp: garment.presented_timestamp
        };
      }
    });
    setSelectedGarmentsObject(selectedGarmentsObject)
    setIgnoredGarmentsObject(ignoredGarmentsObject)
  }, [selectedGarments, garments])

  useEffect(() => {
    setDataLoading(!jobDataLoaded)
  }, [jobDataLoaded])

  //Lifecycle Methods
  useEffect(() => {
    if (openSearchIndex && jobDataLoaded) {
      setDataLoading(true);
      fetchSummonCount();
      setDataLoading(true);
      fetchData();
      setDataLoading(true);
      fetchNamespaceData();
    }
        
    setTotalAggregations(0);
    setSeedGarment(null);
    setSeedGarmentImages([]);
    setGarmentID(null);
    setPage(1);
    setGarments([]);
    setSelectedGarments([]);
    setSelectedGarmentsObject({})
    setIgnoredGarmentsObject({})
    setGarmentsSelectedOnPage(0);
    setDataLoading(false);
  }, [openSearchIndex, jobDataLoaded]);

  useEffect(() => {
    setAnyDataLoading(
      dataLoading || similarItemsDataLoading || proposalDataLoading
    );
  }, [dataLoading, similarItemsDataLoading, proposalDataLoading]);

  useEffect(() => {
    if (garmentID) {
      getSimiliarItems();
      setImageIndex(1);
    }
  }, [garmentID, page, pageSize]);

  useEffect(() => {
    if (garmentID) {
      const start = Date.now();
      const interval = setInterval(() => {
        const elapsed = (Date.now() - start) / 1000; // seconds
        setTime(Math.min(elapsed, timerLengthSeconds)); // clamp to 30
      }, 100);
    
      return () => clearInterval(interval);
    }
  }, [garmentID, page, pageSize])

  useEffect(() => {
    fetchToolData();
    setTotalGarmentsSeen(0);
  }, [])

  useEffect(() => {
    if (selectedGarments.length > 0) {
      setTagMadeOnPage(true);
      setPagesWithoutTag(1);
    }
  }, [selectedGarments]);

  const resetState = () => {
    setSeedGarment(null);
    setSeedGarmentImages([]);
    setImageIndex(1);
    setGarmentID(null);
    setPage(1);
    setGarments([]);
    setSelectedGarmentsObject({});
    setSelectedGarments([]);
    setGarmentsSelectedOnPage(0);
    setIgnoredGarmentsObject({});
    setPagesWithoutTag(0);
    setGarmentsSeen(0);
    fetchNamespaceData();
  };

  const fetchSummonCount = async () => {
    const headers = await getHeaders();

    const params = {
      index: openSearchIndex,
      datasets: datasets,
      pipelineJobId: jobDetails.pipeline_job_link_id,
    };
    
    setDataLoading(true);
    try {
      const headers = await getHeaders();
      const res = await axios.post(
        `${BASE_URL}tools/summon/count/aggregation/`,
        params,
        headers
      )

      const t0 = logPerformancePoint(0);
      setSummonTotal(res.data.data.total_count);
      if (res.data.data.total_count === 0)
      {
        setSeedGarment(null);
      }
      console.log(`res.data.data.total_count: ${res.data.data.total_count}`)
      const t1 = logPerformancePoint(1, t0);
      
      setDataLoading(false);
    } catch (err) {
      showAlert(err);
      setDataLoading(false);
    };
  };

  const fetchNamespaceData = async () => {
    const headers = await getHeaders();
    let url = `${BASE_URL}tools/aggregation/summarystats?`;
    if (openSearchIndex) {
      url += `namespace=${openSearchIndex}&index=brands`;
    }
    axios
      .get(url, headers)
      .then((res) => {
        console.log(`index summary: ${JSON.stringify(res.data.data)}`);
        setIndexSummary(res.data.data);
      })

      .catch((err) => {
        console.log(err);
        showAlert(err);
      });
  };

const fetchToolData = async () => {
  const headers = await getHeaders();
  const formattedToolName = formatToSpacedCapitalizedWords(toolName);
  let url = `${BASE_URL}tools/jobs/tool-names?toolName=${toolName}`;
  axios
    .get(url, headers)
    .then((res) => {
      if (res.data.data && res.data.data.length > 0 && res.data.data[0].id && res.data.data[0].id > 0)
      {
        setToolID(res.data.data[0].id)
      } else {
        const err = `Could not find tool ID in 'tool_names' with name '${formattedToolName}' (formatted from '${toolName}').`
      console.log(err);
        showAlert(err);
      }
    })

    .catch((err) => {
      console.log(err);
      showAlert(err);
    });
};

//API Calls
async function getSimiliarItems() {
  setSimilarItemsDataLoading(true);
  const headers = await getHeaders();
  let data = {
    garment_id: publicGarmentId,
    offset: (page - 1) * pageSize,
    page_size: pageSize,
    index: openSearchIndex,
  };

  await axios
    .post(`${BASE_URL}tools/aggregation/querypinecone`, data, headers)
    .then((res) => {
      const data = res.data.data.map(x => {return { 
        presented_timestamp: presentedTimestamp,
        images: Array.from({ length: x.num_images }, (_, i) => {
            return `https://scraped-garment-images.s3.eu-west-2.amazonaws.com/${
              x.uuid_public_id
            }-${i + 1}.jpg`;
        }), ...x }})
      setGarments(data);
      setGarmentsSeen(garmentsSeen + data.length);
      setTotalGarmentsSeen(totalGarmentsSeen + data.length);
      setSimilarItemsDataLoading(false);
      setPresentedTimestamp(Date.now());
    })
    .catch((err) => {
      console.log(err);
      showAlert(err);
      setPagesWithoutTag(3);
      setSimilarItemsDataLoading(false);
    });
}

async function fetchData() {
  const start = Date.now();
  let end = Date.now();
  const headers = await getHeaders();
  setSeedGarment(null);
  setGarmentID(null);
  setGarments([]);
  setPage(1);
  setSelectedGarmentsObject({});
  setSelectedGarments([]);
  setTagMadeOnPage(false);
  setPagesWithoutTag(0);
  setGarmentsSelectedOnPage(0);
  setGarmentsSeen(0);

  const params = {
    index: openSearchIndex,
    datasets: datasets,
    pipelineJobId: jobDetails.pipeline_job_link_id,
    offsetLimit: 10,
    vectorNamespaceSize: summonTotal ?? 0
  }

  axios
    .post(
      `${BASE_URL}tools/summon/next-item/basic/aggregation`, 
      params,
      headers
    )
    .then((res) => {
      const { num_images, uuid_public_id } = res.data.data;
      let newImages = [];
      for (let i = 0; i < num_images; i++) {
        const prefix =
          "https://scraped-garment-images.s3.eu-west-2.amazonaws.com/";
        const suffix = `${uuid_public_id}-${i + 1}.jpg`;
        newImages.push(prefix + suffix);
      }
      setSeedGarmentImages(newImages);
      setSeedGarment({ ...res.data.data, images: newImages });
      setImageIndex(1);
      setPublicGarmentId(res.data.data.uuid_public_id);
      setGarmentID(res.data.data.garment_id);
      end = Date.now();
      console.log(`Execution time: ${end - start} ms`);
      setProposalDataLoading(false);
      setDataLoading(false);
      setPresentedTimestamp(Date.now());
      setSeedPresentedTimestamp(presentedTimestamp);
    })
    .catch((err) => {
      console.log(err);
      showAlert(err);
      end = Date.now();
      console.log(`Execution time: ${end - start} ms`);
      setProposalDataLoading(false);
      setDataLoading(false);
      setSeedGarment(null);
      setPublicGarmentId(null);
      setGarmentID(null);
    });
  }

  //Handlers
  const handleNext = () => {
    if (!tagMadeOnPage) {
      setPagesWithoutTag(pagesWithoutTag + 1);
    }
    setTagMadeOnPage(false);
    setPage(page + 1);
    setGarmentsSelectedOnPage(
      Object.keys(selectedGarmentsObject).filter((x) =>
        garments.map((y) => y.garment_id.toString()).includes(x)
      ).length
    );
    console.log(`selectedGarmentsObject: ${JSON.stringify(selectedGarmentsObject)}`);
    console.log(
      `pagesWithoutTag: ${pagesWithoutTag} garmentsSelected: ${
        Object.keys(selectedGarmentsObject).length
      } garmentsSelectedOnPage: ${
        Object.keys(selectedGarmentsObject).filter((x) =>
          garments.map((y) => y.garment_id.toString()).includes(x)
        ).length
      }`
    );
    trackEvent("AggregationNextPage", {
      index: openSearchIndex,
      datasetId: selectedDataset?.id,
      garmentId: garmentID,
      aggregations: Object.keys(selectedGarmentsObject).length,
      totalAggregations: totalAggregations,
      selectedGarmentIds: Object.keys(selectedGarmentsObject),
      rejectedGarmentIds: Object.keys(ignoredGarmentsObject),
      garmentsSeen: garmentsSeen,
      totalGarmentsSeen: totalGarmentsSeen,
      jobId: jobDetails.job_id,
      pipelineJobId: jobDetails.pipeline_job_link_id,
      pipelineName: jobDetails.pipeline_name,
      jobName: "aggregation",
      toolType: "AGGREGATION",
      toolName: "AggregationTool",
      toolId: toolID,
      usedVectorNamespaceId: indexSummary.namespaceStats.vectorNamespaceId ?? 0,
      qa: false,
      pages: page,
    });
  };

  const handleSave = async () => {
    setProposalDataLoading(true);
    const data = {
      groupRepresentativeGarmentId: garmentID,
      selectedGarments: selectedGarmentsObject,
      ignoredGarments: ignoredGarmentsObject,
      confidence: 0.4,
      garmentsSeen: garmentsSeen,
      totalGarmentsSeen: totalGarmentsSeen,
      seedPresentedTimestamp: seedPresentedTimestamp,
      seedProposedTimestamp: Date.now(),
      jobId: jobDetails.job_id,
      pipelineJobId: jobDetails.pipeline_job_link_id,
      toolId: toolID,
      vectorNamespaceId: indexSummary.namespaceStats.vectorNamespaceId,
      vectorNamespaceSize: indexSummary?.namespaceStats?.recordCount ?? 0
    };
    const headers = await getHeaders();

    await axios
      .post(`${BASE_URL}tools/classify/basic/aggregation`, data, headers)
      .then(async (res) => {
        setTotalAggregations(
          (prev) =>
            prev +
            (selectedGarmentsObject && Object.keys(selectedGarmentsObject)
              ? Object.keys(selectedGarmentsObject).length
              : 0)
        );
        setTotalIgnoredGarments(
          (prev) =>
            (ignoredGarmentsObject && Object.keys(ignoredGarmentsObject)
              ? Object.keys(ignoredGarmentsObject).length
              : 0)
        );
        console.log(`selectedGarmentsObject: ${JSON.stringify(selectedGarmentsObject)}`);
        console.log(
          `pagesWithoutTag: ${pagesWithoutTag} garmentsSelected: ${
            Object.keys(selectedGarmentsObject).length
          } garmentsSelectedOnPage: ${
            Object.keys(selectedGarmentsObject).filter((x) =>
              garments.map((y) => y.garment_id.toString()).includes(x)
            ).length
          }`
        );
        trackEvent("Aggregation", {
          index: openSearchIndex,
          datasetId: selectedDataset?.id,
          garmentId: garmentID,
          aggregations: Object.keys(selectedGarmentsObject).length,
          totalAggregations:
            totalAggregations +
            (selectedGarmentsObject && Object.keys(selectedGarmentsObject)
              ? Object.keys(selectedGarmentsObject).length
              : 0),
          selectedGarmentIds: Object.keys(selectedGarmentsObject),
          rejectedGarmentIds: Object.keys(ignoredGarmentsObject),
          garmentsRejected: Object.keys(ignoredGarmentsObject).length,
          garmentsSelected: Object.keys(selectedGarmentsObject).length,
          garmentsSeen: garmentsSeen,
          totalGarmentsSeen: totalGarmentsSeen,
          jobId: jobDetails.job_id,
          pipelineJobId: jobDetails.pipeline_job_link_id,
          pipelineName: jobDetails.pipeline_name,
          jobName: "aggregation",
          toolType: "AGGREGATION",
          toolName: "AggregationTool",
          toolId: toolID,
          usedVectorNamespaceId: indexSummary.namespaceStats.vectorNamespaceId ?? 0,
          qa: false,
          skipped: false,
        });

        fetchSummonCount();
        fetchData();
        fetchNamespaceData();
        resetState();
        setGarmentsSeen(0);
      })
      .catch((err) => {
        console.log(err);
        showAlert(err);
        setGarmentsSeen(0);
        setProposalDataLoading(false);
      });
  };

  const handleSkip = async () => {
    setProposalDataLoading(true);
    const data = {
      groupRepresentativeGarmentId: garmentID,
      selectedGarments: selectedGarmentsObject,
      ignoredGarments: ignoredGarmentsObject,
      confidence: 0.4,
      garmentsSeen: garmentsSeen,
      totalGarmentsSeen: totalGarmentsSeen,
      seedPresentedTimestamp: seedPresentedTimestamp,
      seedProposedTimestamp: Date.now(),
      jobId: jobDetails.job_id,
      pipelineJobId: jobDetails.pipeline_job_link_id,
      toolId: toolID,
      vectorNamespaceId: indexSummary.namespaceStats.vectorNamespaceId,
      vectorNamespaceSize: indexSummary?.namespaceStats?.recordCount ?? 0
    };
    const headers = await getHeaders();

    await axios
      .post(`${BASE_URL}tools/classify/skip/aggregation`, data, headers)
      .then((res) => {
        setTotalAggregations(
          totalAggregations + (selectedGarmentsObject ? Object.keys(selectedGarmentsObject).length : 0)
        );
        setTotalIgnoredGarments(
          (prev) => prev + (garments - Object.keys(selectedGarmentsObject).length)
        );
        console.log(`selectedGarmentsObject: ${JSON.stringify(selectedGarmentsObject)}`);
        console.log(
          `pagesWithoutTag: ${pagesWithoutTag} garmentsSelected: ${
            Object.keys(selectedGarmentsObject).length
          } garmentsSelectedOnPage: ${
            Object.keys(selectedGarmentsObject).filter((x) =>
              garments.map((y) => y.garment_id.toString()).includes(x)
            ).length
          }`
        );

        trackEvent("Aggregation", {
          index: openSearchIndex,
          datasetId: selectedDataset?.id,
          garmentId: garmentID,
          aggregations: Object.keys(selectedGarmentsObject).length,
          totalAggregations:
            totalAggregations +
            (selectedGarmentsObject ? Object.keys(selectedGarmentsObject).length : 0),
          selectedGarmentIds: Object.keys(selectedGarmentsObject),
          rejectedGarmentIds: Object.keys(ignoredGarmentsObject),
          garmentsRejected: Object.keys(ignoredGarmentsObject).length,
          garmentsSelected: Object.keys(selectedGarmentsObject).length,
          garmentsSeen: garmentsSeen,
          totalGarmentsSeen: totalGarmentsSeen,
          jobId: jobDetails.job_id,
          pipelineJobId: jobDetails.pipeline_job_link_id,
          pipelineName: jobDetails.pipeline_name,
          jobName: "aggregation",
          toolType: "AGGREGATION",
          toolName: "AggregationTool",
          toolId: toolID,
          usedVectorNamespaceId: indexSummary.namespaceStats.vectorNamespaceId ?? 0,
          qa: false,
          skipped: true,
        });

        setSelectedGarmentsObject({});
        setSelectedGarments([]);
        setIgnoredGarmentsObject({});
        setGarmentsSeen(0);
        resetState();
        fetchSummonCount();
        fetchData();
        fetchNamespaceData();
      })
      .catch((err) => {
        console.log(err);
        showAlert(err);
        setGarmentsSeen(0);
        setProposalDataLoading(false);
      });
  };

  //Renderers
  const renderGarment = (garment, index) => {
    return (
      <GarmentPanel
        garment={garment}
        height={"20vh"}
        xs={12 / numberOfColumns} // Dynamic xs based on the number of columns
        setSelectedGarmentsObject={setSelectedGarmentsObject}
        setIgnoredGarmentsObject={setIgnoredGarmentsObject}
        presentedTimestamp={presentedTimestamp}
        imageIndex={imageIndex}
        ignoredGarments={ignoredGarmentsObject}
        selectedGarments={selectedGarmentsObject}
        index={index + 1 + (page - 1) * pageSize} // Calculate index based on page and page size
      />
    );
  };

  return (
    <Box
      sx={{
        height: `calc(100vh - ${APP_BAR_HEIGHT}px)`,
        display: "flex",
        flexDirection: "column"
      }}
    >
      <LoadingOverlay open={dataLoading || similarItemsDataLoading || proposalDataLoading}
        text={
          similarItemsDataLoading
            ? "Loading Garments"
            : proposalDataLoading
            ? "Loading Seed Garment"
            : ""
        }/>
      
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          mt: 1,
          pb: 1,
          px: 2
        }}
      >
        <Typography variant="h2" sx={{ 
          mb: 1, 
          mt: 1,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          width: "100%"
        }}>
          Aggregation Tool
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            mt: 2,
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={handleNext}
            sx={{ 
              color: theme.palette.primary[100],
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              width: "100%" 
            }}
            disabled={anyDataLoading || pagesWithoutTag === 3 || time < timerLengthSeconds}
          >
            Next Page
          </Button>
          <Button
            variant="contained"
            color="primary"
            sx={{
              marginLeft: 2,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              width: "100%",
              px: 3
            }}
            onClick={() => {
              if (Object.keys(selectedGarmentsObject).length > 0) {
                handleSave();
              } else {
                if (seedGarment.is_in_group)
                {
                  handleSkip();
                } else {
                  setSkipOrCreateOpen(true);
                }
              }
            }}
            disabled={anyDataLoading || pagesWithoutTag < 3 || time < timerLengthSeconds}
          >
            New Garment
          </Button>
        </Box>
      </Box>

      <Box sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-end",
        mr: 2,
      }}>
        <LoadingBar time={time} maxTime={timerLengthSeconds} sx={{maxWidth: "19rem"}}/>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          height: 60,
          alignContent: "center",
          mx: 2,
          mt: -1
        }}
      >
        <PineconeIndexDropdown
          index={openSearchIndex}
          setIndex={setOpenSearchIndex}
        />
        <Select
          value={numberOfColumns}
          onChange={(e) => setNumberOfColumns(e.target.value)}
          displayEmpty
          sx={{ ml: 2 }}
        >
          <MenuItem value={4}>4 Columns</MenuItem>
          <MenuItem value={5}>5 Columns</MenuItem>
          <MenuItem value={6}>6 Columns</MenuItem>
          <MenuItem value={7}>7 Columns</MenuItem>
          <MenuItem value={8}>8 Columns</MenuItem>
        </Select>
      </Box>

      <Divider
        sx={{
          m: 1,
        }}
      />

      <Box
        sx={{
          flexGrow: 1, // Fills the remaining space
          display: "flex",
          overflow: "hidden", // Ensures no overflow outside this box
          px: 2
        }}
      >
        <Grid container sx={{height: "90vh"}}>
          <Grid
            xs={12}
            md={3}
            sx={{ height: "90vh"}}
          >
            <Typography variant="h3">Seed Garment</Typography>

            {seedGarment && (
              <SeedGarment garment={seedGarment} sx={{py: 1, pb: 6, mb: -8, height: "75%"}} sxImageCarousel={{height: "80%"}} />
            )}
          </Grid>

          <Grid container xs={12} md={9} sx={{height: "75%"}}>
            {((!seedGarment || !seedGarment.images) || (!summonTotal || summonTotal === 0) || garments.length === 0) && !dataLoading
            ? (
              <NoDataScreenCover customTitle={seedGarment ? "No similar data found" : null} customSubtitle={seedGarment ? "could not find any similar items in the pinecone namespace - this may be a new item" : null} showBackButton={false} />
            )
            : <Box sx={{ml: 2}}>
              <Typography variant="h3" sx={{mb: 1, ml: 1}}>Garment Pool</Typography>
              <MassImageApprovalsFrame
                sx={{p: 2, pl: 0, pt: 0}}
                garments={garments}
                selectedGarments={selectedGarments}
                setSelectedGarments={setSelectedGarments}
                disabled={false}
                reject={false}
                numberOfColumns={numberOfColumns}
                presentedTimestamp={presentedTimestamp}
                disableGarmentsInGroup={true}
            /></Box>}
          </Grid>
        </Grid>
      </Box>
      
      <Divider
          sx={{
            m: 1,
          }}
        />

      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          px: 2,
          pb: 1
        }}
      >
        <Typography variant="body_sm">
          Session Count: {totalAggregations}
        </Typography>
        <Typography variant="body_sm">
          Currently Selected: {selectedGarments.length}
        </Typography>
        <Typography variant="body_sm">
          Total Matched: <Typography variant="body_sm" color="success.main">{totalAggregations}</Typography>
        </Typography>
        <Typography variant="body_sm">
          Total Rejected: <Typography variant="body_sm" color="error.main">{totalIgnoredGarments}</Typography>
        </Typography>
        <Typography variant="body_sm">Seed ID: {garmentID}</Typography>
      </Box>

      <CustomModal
        showModal={skipOrCreateOpen}
        title="Skip Seed Garment or Create New Group?"
        body={<>Would you like to create a new group with this seed garment, or skip the garment?<br /><b>Please check all seed garment images in the carousel - only skip if all images are poor quality resulting in (strange garments in the grid).</b></>}
        onDismiss={() => {
          handleSkip();
          setSkipOrCreateOpen(false);
        }}
        onConfirm={() => {
          handleSave();
          setSkipOrCreateOpen(false);
        }}
        onDismissColour="error"
        onDismissTitle="Skip"
        onConfirmTitle="Create new Group"
      />
    </Box>
  );
}

function WrappedAggregationTool() {
  const { id } = useParams();
  return (
    <ToolProvider id={id}>
      <AggregationTool />
    </ToolProvider>
  );
}

export default WrappedAggregationTool;
